import { useEffect, useRef } from "react"
import { themeI18n } from "../utils/i18n_helper.js";
import { lockScroll, releaseScroll } from "../utils/scrollLock.js";

import Icons from "./Icons.js";

// Reproduces the layout and functionality of the drawer.liquid snippet
// To create a button to open the drawer, dispatch an event with the same name as the drawer's openEvent prop
export const Drawer = ({ children, openEvent, direction, headerContent, contentClass }) => {
  const detailsRef = useRef(null);

  useEffect(()=> {
    window.addEventListener(openEvent, openDrawer);
    window.addEventListener("close_" + openEvent, closeDrawer);

    return () => {
      window.removeEventListener(openEvent, openDrawer);
      window.removeEventListener("close_" + openEvent, closeDrawer);
    }
  }, [])

  const openDrawer = () => {
    detailsRef.current.setAttribute('open', true);
    lockScroll('Drawer');
  }

  const closeDrawer = () => {
    detailsRef.current.setAttribute('closing', true);
    releaseScroll('Drawer');

    setTimeout(() => {
      detailsRef.current.removeAttribute('open');
      detailsRef.current.removeAttribute('closing');
    }, 500);
  }

  return (
    <div className="drawer">
      <details ref={detailsRef} className="drawer__details">
        <summary></summary>

        <div className={`drawer__inner ${direction == 'left' && 'drawer__inner--left'}`}>
          <div className="drawer__inner-background" onClick={closeDrawer}></div>

          <div className="drawer__inner-content-wrapper {{ additional_classes }}">
            <div className="drawer__header">
              <button onClick={closeDrawer} className="drawer__close-button" role="button" aria-label={themeI18n('accessibility.close')}>
                <Icons icon="close" />
              </button>

              {headerContent && (
                <div className="drawer__header-content h4">
                  <p>{headerContent}</p>
                </div>
              )}
            </div>

            <div className={`drawer__inner-content ${contentClass}`}>
              {children}
            </div>
          </div>
        </div>
      </details>
    </div>
  )
}
